import { render, staticRenderFns } from "./Pushlist.vue?vue&type=template&id=2353daf1&scoped=true&"
import script from "./Pushlist.vue?vue&type=script&lang=js&"
export * from "./Pushlist.vue?vue&type=script&lang=js&"
import style0 from "./Pushlist.vue?vue&type=style&index=0&id=2353daf1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2353daf1",
  null
  
)

export default component.exports